import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import Login from './modulos/login/Login';
import Diseno from './comun/Diseno';
import ListaUsuarios from './modulos/usuarios/ListaUsuarios';
import ServicePlaceholder from './components/ServicePlaceholder';
import PanelFastFood from './modulos/fast-food/PanelFastFood';
import Inventario from './modulos/fast-food/Inventario';
import Bodega from './modulos/fast-food/Bodega';
import Mezclas from './modulos/fast-food/Mezclas';
import Ordenes from './modulos/fast-food/Ordenes';
import Clientes from './modulos/fast-food/Clientes';
import Reportes from './modulos/fast-food/Reportes';
import PuntosVenta from './modulos/fast-food/PuntosVenta';
import TasaDeCambio from './modulos/fast-food/TasaDeCambio';
import PanelCaja from './modulos/fast-food/Caja/PanelCaja';
import Impresoras from './modulos/fast-food/Impresoras';
import Promociones from './modulos/fast-food/Promociones';
import Gastos from './modulos/fast-food/Gastos';
import Toppings from './modulos/fast-food/Toppings';
import Variables from './modulos/fast-food/Variables';
import ReportesPeriodicos from './modulos/fast-food/ReportesPeriodicos';
import FacturacionSRI from './modulos/fast-food/FacturacionSRI';
import PanelCobranzas from './modulos/cobranzas/PanelCobranzas';
import ConfiguracionSecuencia from './modulos/fast-food/ConfiguracionSecuencia';
import Mesas from './modulos/fast-food/Mesas';
import logo from './assets/logo.png';
import './App.css';

// Componente para proteger rutas
const PrivateRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <Diseno>{children}</Diseno>;
};

const FastFoodRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <div>Cargando...</div>;
  if (!user) return <Navigate to="/login" />;

  // Usamos el diseño general para todos, la barra lateral filtrará los items
  return <Diseno>{children}</Diseno>;
};

// Componente para proteger la ruta de Cobranzas (Solo GESTOR_COBRANZAS)
const GestorCobranzasRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <div>Cargando...</div>;
  if (!user) return <Navigate to="/login" />;
  if (user?.role_details?.name !== 'GESTOR_COBRANZAS') {
    return <Navigate to="/fast-food/pos" />;
  }

  return <Diseno>{children}</Diseno>;
};

// Dashboard simple
const Dashboard = () => {
  const { user } = useContext(AuthContext);
  const roleName = user?.role_details?.name;
  
  if (roleName === 'GESTOR_COBRANZAS') {
      return <Navigate to="/cobranzas" />;
  }

  if (roleName !== 'SUPER_ADMIN' && !user?.is_superuser) {
      return <Navigate to="/fast-food/pos" />;
  }

  return (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh',
    backgroundColor: '#ffffff',
    color: 'var(--primary-color)',
    textAlign: 'center',
    borderRadius: '24px',
    padding: '4rem 2rem',
    margin: '1rem',
    border: '1px solid var(--border-color, #e8ded1)',
    boxShadow: '0 10px 30px rgba(96, 56, 51, 0.06)'
  }}>
    <img src={logo} alt="TioNel" style={{ height: '220px', marginBottom: '2rem', objectFit: 'contain' }} />
    <h2 style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '1rem', color: 'var(--primary-color)' }}>Bienvenido a TioNel</h2>
    <p style={{ fontSize: '1.2rem', color: 'var(--text-secondary, #78605c)', maxWidth: '600px', lineHeight: '1.6' }}>Seleccione una opción del menú lateral para comenzar a administrar su negocio.</p>
  </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />

          <Route path="/users" element={
            <PrivateRoute>
              <ListaUsuarios />
            </PrivateRoute>
          } />

          {/* Rutas de creación/edición eliminadas porque ahora son Modales */}

          <Route path="/fast-food" element={
            <FastFoodRoute>
              <PanelFastFood />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/inventory" element={
            <FastFoodRoute>
              <Inventario />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/toppings" element={
            <FastFoodRoute>
              <Toppings />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/variables" element={
            <FastFoodRoute>
              <Variables />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/promotions" element={
            <FastFoodRoute>
              <Promociones />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/bodega" element={
            <FastFoodRoute>
              <Bodega />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/mezclas" element={
            <FastFoodRoute>
              <Mezclas />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/orders" element={
            <FastFoodRoute>
              <Ordenes />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/customers" element={
            <FastFoodRoute>
              <Clientes />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/reports" element={
            <FastFoodRoute>
              <Reportes />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/periodic-reports" element={
            <FastFoodRoute>
              <ReportesPeriodicos />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/pos" element={
            <FastFoodRoute>
              <PuntosVenta />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/tasa-cambio" element={
            <FastFoodRoute>
              <TasaDeCambio />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/shift" element={
            <FastFoodRoute>
              <PanelCaja />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/feria-shift" element={
            <FastFoodRoute>
              <PanelCaja isFeriaMode={true} />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/gastos" element={
            <FastFoodRoute>
              <Gastos />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/facturacion-sri" element={
            <FastFoodRoute>
              <FacturacionSRI />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/printers" element={
            <FastFoodRoute>
              <Impresoras />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/secuencia" element={
            <FastFoodRoute>
              <ConfiguracionSecuencia />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/tables" element={
            <FastFoodRoute>
              <Mesas />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/mesas" element={
            <FastFoodRoute>
              <Mesas />
            </FastFoodRoute>
          } />


          <Route path="/cobranzas" element={
            <GestorCobranzasRoute>
              <PanelCobranzas />
            </GestorCobranzasRoute>
          } />

          <Route path="/hotel" element={
            <PrivateRoute>
              <ServicePlaceholder title="Hotel" />
            </PrivateRoute>
          } />

          <Route path="/pool" element={
            <PrivateRoute>
              <ServicePlaceholder title="Piscinas" />
            </PrivateRoute>
          } />

          <Route path="/restaurant" element={
            <PrivateRoute>
              <ServicePlaceholder title="Restaurante" />
            </PrivateRoute>
          } />

          {/* Redirigir cualquier otra ruta al inicio */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
